import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'I RISULTATI DELLA TUA RICERCA',
        description:
            'Le verifiche sono presentate dalla più recente in poi. Per ogni verifica vedi subito le informazioni base e il numero di esercizi presenti.',
        name: 'SpecialHomeworkCardContainerWithTutorial',
        tutorialName: 'verifica_risultati-prove-speciali-Zanichelli'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 35,
        yOffset: -35
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 10,
        yOffset: -30
    }
};
